import AbstractEntity from "../AbstractEntity";

export default class ArtisanComment extends AbstractEntity {
    _id;
    _content;
    _createdAt;
    _interventionId;


    getId() {
        return this._id;
    }

    getContent() {
        return this._content;
    }

    getCreatedAt() {
        return this._createdAt;
    }

    getInterventionId() {
        return this._interventionId;
    }

    getClassName() {
        return "artisan_comment";
    }
}